import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import ScrollReveal from "scrollreveal";
import modaal from 'modaal';
import modal from './app/modal.js';

import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";


import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

import modaalCss from 'modaal/dist/css/modaal.css';

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();
    this.modal = new modal();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      // console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //カウントアップ
    function countUp() {
      var selector = '.js-countup';     // 対象のDOMのセレクタ
      var $years = $(selector);
      $years.each(function () {
        var year = $(this).text();
        $(this).text(year - 20);
        var tempyear = year - 20;
        var self = this;
        var scrollStart = function () {
          if (($(self).offset().top - 700) < $(window).scrollTop()) {
            var interval = setInterval(function () {
              if (tempyear < year) {
                tempyear++;
                $(self).text(tempyear);
              } else {
                clearInterval(interval);
                return false;
              }
            }, 50)
          } else {
            window.requestAnimationFrame(scrollStart)
          }
        }
        window.requestAnimationFrame(scrollStart)
      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: false,
          loop: true,
          nav: false,
          autoplayHoverPause: false,
          autoplay: true,
          autoplaySpeed: 800,
          autoWidth: false,
          autoHeight: false,
          center: true,
          animateOut: 'fadeOut',
          navText: ['<img src="/recruit/wp-content/themes/ckcnet-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/recruit/wp-content/themes/ckcnet-html/dist/assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カルーセル
      owls.imagesLoaded(function () {
        $('.c-block-slider__carousel').owlCarousel({
          items: 2,
          margin: 8,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: false,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/recruit/wp-content/themes/ckcnet-html/dist/assets/images/icon-slider-round-prev.png" />', '<img src="/recruit/wp-content/themes/ckcnet-html/dist/assets/images/icon-slider-round-next.png" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
              margin: 8,
            },
            // breakpoint from 750 up
            950: {
              items: 2,
            },
          }
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          navText: ['<img src="/recruit/wp-content/themes/ckcnet-html/dist/assets/images/icon-slider-prev.png" />', '<img src="/recruit/wp-content/themes/ckcnet-html/dist/assets/images/icon-slider-next.png" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
              margin: 12,
              stagePadding: 20,
              center: true,
            },
            // breakpoint from 750 up
            950: {
              items: 2,
              margin: 32,
              stagePadding: 60,
              center: true,
            },
            // breakpoint from 750 up
            1250: {
              items: 3,
              margin: 32,
              stagePadding: 60,
              center: true,
            },
            // breakpoint from 1401 up
            1580: {
              items: 2,
              margin: 40,
              stagePadding: 400,
              center: false,
            }
          }
        });
      });
    }

    function reveal() {
      //- スクロールリーバル
      window.sr = ScrollReveal({duration: 600});

      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }

      sr.reveal(".c-main-visual", {
        delay: 400,
        opacity: 0,
        scale: 1,
        duration: 400,
        origin: 'top',
        distance: '-8px',
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
      }, 100);
      sr.reveal(".l-page-header,.c-block-message", {
        delay: 200,
        opacity: 0,
        scale: 1,
        duration: 400,
        origin: 'top',
        distance: '8px',
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
      }, 100);
      sr.reveal(".c-main-visual__inner", {
        delay: 800,
        scale: 1,
        duration: 400,
        origin: 'top',
        distance: '8px',
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
      }, 100);
      sr.reveal(".c-card-box", {
        delay: 400,
        scale: 1,
        duration: 400,
        origin: 'top',
        distance: '8px',
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
      }, 100);
      sr.reveal(".c-block-number__image", {
        delay: 600,
        scale: 0.9,
        duration: 400,
        origin: 'top',
        distance: '-8px',
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
      }, 100);
      sr.reveal(".c-block-number__content", {
        delay: 1000,
        scale: 1,
        duration: 400,
        origin: 'top',
        distance: '8px',
        easing: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
      }, 100);

      var blocks01 = $(".c-hero-block");
      domEach(blocks01, function (key, item) {
        sr.reveal(item, {scale: 1, duration: 700, delay: 300, origin: 'bottom', distance: '8px'}, 200);
        sr.reveal(item.children[1], {delay: 500, scale: 1, duration: 700, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[2], {delay: 600, scale: 1, duration: 700, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[3], {delay: 700, scale: 1, duration: 700, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[4], {delay: 800, scale: 1, duration: 700, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[5], {delay: 900, scale: 1, duration: 700, origin: 'bottom', distance: '8px'}, 300);
        sr.reveal(item.children[6], {delay: 1000, scale: 1, duration: 700, origin: 'bottom', distance: '8px'}, 300);
      });
    }

    function pad(n) {
      if (n < 10) return "0" + n;
      return n;
    }

    function slick() {
      $('.c-top-project__slider').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        $('.c-top-project__slick-num-curr').text(pad(i));
        $('.c-top-project__slick-num-all').text(pad(slick.slideCount));
      });
      $('.c-top-project__slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 5000,
        focusOnSelect: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        swipeToSlide: true,
        arrows: true,
        nextArrow: '<img src="/recruit/wp-content/themes/ckcnet-html/dist/assets/images/icon-arrow-right.png" class="slide-arrow next-arrow">'
      });
    }

    function modalNumbers() {
      var items = $('.c-block-numbers__item');
      $(items).on('click', function () {
        $(this).toggleClass('is-active');
      });
    }

    function slickSlider() {

      let mainItems = [];
      let thumbItems = [];

      if (!$(".c-works-slider__main").length) {
        return;
      }

      $(".c-works-slider__main").each(function (index, element) {
        const className = "c-works-slider__main";

        const number = index + 1;
        const addClassName = className + number;
        mainItems[index] = "." + addClassName;
        $(element).addClass(addClassName);
      });

      $(".c-works-slider__thumbnail").each(function (index, element) {
        const className = "c-works-slider__thumbnail";

        const number = index + 1;
        const addClassName = className + number;
        thumbItems[index] = "." + addClassName;
        $(element).addClass(addClassName);
      });


      const $slider_mains = $('.c-works-slider__main');
      $slider_mains.each(function (index, element) {
        $(element).slick({
          infinite: true,
          arrow: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          // prevArrow: '<div class="slick-prev" style="background-image:url(/wp-content/themes/yamato-sekizai-html/dist/assets/images/icon-slider-prev-lg.png)"></div>',
          // nextArrow: '<div class="slick-next" style="background-image:url(/wp-content/themes/yamato-sekizai-html/dist/assets/images/icon-slider-next-lg.png)"></div>',
          asNavFor: thumbItems[index],
          autoplaySpeed: 2500,
          // centerPadding: '23.28%',
          centerPadding: '60px',
          centerMode: true,
          variableWidth: true,
          responsive: [{
            breakpoint: 750,
            settings: {
              dots: false,
              variableWidth: false
            }
          }]
        });
      });

      const $slider_thumbs = $('.c-works-slider__thumbnail');
      $slider_thumbs.each(function (index, element) {
        let item_length = $(element).find('.c-works-slider__thumbnail-image').length;

        // console.log(item_length);

        let pcShowNum = 5;
        let spShowNum = 4;
        let spIsDots = true;

        if (item_length <= pcShowNum) {
          pcShowNum = item_length;
          $(element).addClass("is-restrict-pc");
          if (item_length < pcShowNum) {
            $(element).addClass("is-narrow");
          }
        }
        if (item_length <= spShowNum) {
          spShowNum = item_length;
          spIsDots = false;
          $(element).addClass("is-restrict-sp");
        }

        $(element).slick({
          accessibility: true,
          autoplay: true,
          autoplaySpeed: 4000,
          speed: 400,
          arrows: false,
          dots: false,
          infinite: true,
          slidesToShow: pcShowNum,
          slidesToScroll: 1,
          asNavFor: mainItems[index],
          focusOnSelect: true,
          // variableWidth: false,
          responsive: [{
            breakpoint: 750,
            settings: {
              dots: spIsDots,
              variableWidth: false,
              autoplaySpeed: 2500,
              slidesToShow: spShowNum
            }
          }]
        });
      });
    }

    function homeAdjust() {
      let viewportHeight = window.innerHeight;
      let viewportWidth = window.innerWidth;

      init(viewportWidth, viewportHeight);

      $(window).resize(function () {
        const newViewportHeight = window.innerHeight;
        const newViewportWidth = window.innerWidth;

        if (viewportWidth > 750) { // PCの場合は高さ変更をトリガーにする
          if (newViewportHeight !== viewportHeight) {
            init(newViewportWidth, newViewportHeight);
          }
        } else { // SPの場合は横幅変更をトリガーにする
          if (newViewportWidth !== viewportWidth) {
            init(newViewportWidth, newViewportHeight);
          }
        }
        // 初期値を更新
        viewportHeight = newViewportHeight;
        viewportWidth = newViewportWidth;
      });

      function init(wWidth, wHeight) {
        if ($("body").hasClass("top") || $("body").hasClass("home")) { // homeはWP用
          let setHeight = wHeight;
          const headerHeight = $(".l-header-variable").outerHeight();

          let viewHeight = wHeight;
          if (wWidth > 750) {
            viewHeight = wHeight - headerHeight;
          }

          const minHeight = 600;
          if (wHeight < minHeight) {
            viewHeight = minHeight;
            setHeight = minHeight;
          }

          $(".c-block-main-visual-text").height(viewHeight);
          $(".c-main-visual").height(setHeight);
        }
      }
    }

    function modaal() {
      const viewportWidth = window.innerWidth;

      if (viewportWidth < 751) {
        $(".js-modal-image-sp").modaal({
          type: 'image'
        });
      }
    }

    $(function () {
      menuSlide();
      owlCarousel();
      countUp();
      reveal();
      modalNumbers();
      slick();
      slickSlider();
      homeAdjust();
      modaal();
    });
  }
}

window.GApp = new App();
